var LabelButton          = require("./LabelButton");

var PointButton = LabelButton.extend({

    /**
     *
     */
    initialize: function(options){
        var that = this;

        that._map = undefined;
        that._measurement = undefined;

        PointButton.__super__.initialize.call(that, options);

        that.getContainer()
            // .addClass('PointButton')
            .on('click', function(e){
                that._measurement.changeInteraction('Point');
            });
    },

    /**
     *
     */
    onAdd: function(view){
        var that = this;

        that._map = view.getMap();
        that._measurement = view.getMeasurement();
        that._measurement.on('measureChanged', function(event){
            if (event.measureType == 'Point') {
                that.getContainer().addClass('active');
            } else {
                that.getContainer().removeClass('active');
            }
        });
    }
});

module.exports = PointButton;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/PointButton.js
// module id = 247
// module chunks = 0